import { render, staticRenderFns } from "./ModalAddToPolicy.vue?vue&type=template&id=068903f5&scoped=true&"
import script from "./ModalAddToPolicy.vue?vue&type=script&lang=js&"
export * from "./ModalAddToPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddToPolicy.vue?vue&type=style&index=0&id=068903f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068903f5",
  null
  
)

export default component.exports